import { Helmet } from 'react-helmet-async';

const SITE = 'Vintage Wardrobe Co.';
const SITE_TAGLINE = 'Curated Vintage & Streetwear';
const DEFAULT_DESC = 'Shop curated vintage and retro streetwear at Vintage Wardrobe Co. Oversized hoodies, vintage jackets, cargo pants, tees and more. Handpicked, supplier-backed. Free UK shipping over £50.';
const OG_IMAGE = 'https://vintagewardrobe.co/og-image.png';
const SITE_URL = 'https://vintagewardrobe.co';

export const SEO = ({ title, description, path, type = 'website', image, product }) => {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} | ${SITE_TAGLINE}`;
  const desc = description || DEFAULT_DESC;
  const img = image || (product && product.images && product.images[0]) || OG_IMAGE;
  const url = path ? `${SITE_URL}${path}` : SITE_URL;

  // Build Product structured data for product pages
  const productSchema = product ? JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Product",
    "name": product.name,
    "description": (product.description || '').replace(/\n/g,' ').substring(0, 500),
    "image": product.images || [],
    "url": url,
    "brand": {
      "@type": "Brand",
      "name": "Vintage Wardrobe Co."
    },
    "offers": {
      "@type": "Offer",
      "price": product.price,
      "priceCurrency": "GBP",
      "availability": product.stock > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
      "url": url,
      "seller": {
        "@type": "Organization",
        "name": "Vintage Wardrobe Co."
      },
      "shippingDetails": {
        "@type": "OfferShippingDetails",
        "shippingRate": {
          "@type": "MonetaryAmount",
          "value": "0",
          "currency": "GBP"
        },
        "shippingDestination": {
          "@type": "DefinedRegion",
          "addressCountry": "GB"
        },
        "deliveryTime": {
          "@type": "ShippingDeliveryTime",
          "businessDays": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"]
          },
          "cutoffTime": "17:00:00",
          "handlingTime": {
            "@type": "QuantitativeValue",
            "minValue": 1,
            "maxValue": 2,
            "unitCode": "DAY"
          },
          "transitTime": {
            "@type": "QuantitativeValue",
            "minValue": 7,
            "maxValue": 15,
            "unitCode": "DAY"
          }
        }
      }
    },
    "returnPolicy": {
      "@type": "MerchantReturnPolicy",
      "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
      "merchantReturnDays": 30,
      "returnMethod": "https://schema.org/ReturnByMail"
    }
  }) : null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="en_GB" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {productSchema && (
        <script type="application/ld+json">{productSchema}</script>
      )}
    </Helmet>
  );
};
